// @flow
import React, { Component } from 'react';
import GoogleOneTap from 'app/common/react/components/growth/unauth/signup/GoogleOneTap/GoogleOneTap';
import type { FacebookUserData } from 'app/packages/pinterest-flow-types/authentication';
import type { GenericAuthenticationCredsType } from 'app/packages/pinterest-authentication/registration';
import type { SignupCredentialsAndLoggingData } from 'app/packages/pinterest-flow-types/registration';

type OwnProps = {|
  container?: string,
  handleFailureToShow?: () => void,
  handleSignupConfirmed?: (
    method: string,
    userData: FacebookUserData | { email?: string },
    credentials: SignupCredentialsAndLoggingData,
  ) => void,
  handleLoginError: (error: Object) => void,
  handleLoginWithMfa: (creds: GenericAuthenticationCredsType) => void,
  handleSignupError: () => void,
  handleShowLogin: () => void,
  nextUrl?: string,
  shouldHide?: boolean,
  showRegisterLoadingScreen?: (boolean) => void,
|};

type State = {|
  showGoogleOneTap: boolean,
|};

class GoogleOneTapPresenter extends Component<OwnProps, State> {
  static defaultProps = {
    container: 'unknown',
    shouldHide: false,
  };

  state: State = {
    showGoogleOneTap: true,
  };

  hide = () => {
    this.setState({ showGoogleOneTap: false });
  };

  reportFailureToShow = () => {
    if (this.props.handleFailureToShow) {
      this.props.handleFailureToShow();
    }
  };

  render() {
    const { showGoogleOneTap } = this.state;
    const {
      container,
      handleSignupConfirmed,
      handleLoginError,
      handleLoginWithMfa,
      handleSignupError,
      handleShowLogin,
      nextUrl,
      shouldHide,
      showRegisterLoadingScreen,
    } = this.props;
    if (!showGoogleOneTap) {
      return null; // render must return `null` so that the component can be mounted
    }

    return (
      <GoogleOneTap
        container={container}
        handleEmptyCredentials={this.hide}
        handle2FALogin={(creds) => {
          this.hide();
          handleLoginWithMfa(creds);
        }}
        handleLoginError={(error) => {
          this.hide();
          handleLoginError(error);
        }}
        handleSignupConfirmed={(
          method: string,
          userData: FacebookUserData | { email?: string },
          credentials: SignupCredentialsAndLoggingData,
        ) => {
          this.hide();
          if (handleSignupConfirmed) {
            handleSignupConfirmed(method, userData, credentials);
          }
        }}
        handleSignupError={() => {
          this.hide();
          handleSignupError();
        }}
        handleShowLogin={() => {
          this.hide();
          handleShowLogin();
        }}
        nextUrl={nextUrl}
        reportFailureToShow={this.reportFailureToShow}
        showRegisterLoadingScreen={(shouldShow) => {
          if (showRegisterLoadingScreen) {
            this.hide();
            showRegisterLoadingScreen(shouldShow);
          }
        }}
        shouldHide={shouldHide}
      />
    );
  }
}

export default GoogleOneTapPresenter;
